import { z } from "zod";

export const DetectorModeSchema = z.enum([
  "HostOnly",
  "SalespersonOnly",
  "Anyone",
]);
export type DetectorMode = z.infer<typeof DetectorModeSchema>;

export const SimilarityThresholdsSchema = z.object({
  partial: z.number().min(0).max(1),
  full: z.number().min(0).max(1),
  embedding: z.number().min(0).max(1),
});
export type SimilarityThresholds = z.infer<typeof SimilarityThresholdsSchema>;

export const OpenAIProcessingModeSchema = z.enum([
  "inline", // Synchronous processing (for tests)
  "queue", // Async queue-based processing (for production)
]);
export type OpenAIProcessingMode = z.infer<typeof OpenAIProcessingModeSchema>;

export const DetectorConfigSchema = z.object({
  maxLookAhead: z.number().int().positive(),
  embeddingFallbackThreshold: z.number().min(0).max(100),
  bufferSize: z.number().int().positive(),
  similarityThresholds: SimilarityThresholdsSchema,
  timeThreshold: z.number().int().positive(),
  initialMode: DetectorModeSchema,
  keywordMatchThreshold: z.number().min(0).max(1),
  openAIProcessingMode: OpenAIProcessingModeSchema.default("queue"),
});
export type DetectorConfig = z.infer<typeof DetectorConfigSchema>;
